import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  iconOnly?: boolean;
}

/** Official Tally mark: gradient rounded-square "T" icon + wordmark. */
export function Logo({ className, iconOnly }: LogoProps) {
  return (
    <span
      className={cn('inline-flex items-center gap-2 font-semibold tracking-tight', className)}
    >
      <img
        src="/brand/tally-icon-64.png"
        srcSet="/brand/tally-icon-64.png 1x, /brand/tally-icon-192.png 3x"
        alt={iconOnly ? 'Tally' : ''}
        aria-hidden={iconOnly ? undefined : true}
        className="h-7 w-7 select-none"
        draggable={false}
      />
      {iconOnly ? null : <span className="text-base">Tally</span>}
    </span>
  );
}
